import React, { useEffect, useState } from 'react';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import Pagination from '@mui/material/Pagination';
import { useMyContext } from '../../../../context/MyContext';
import { FaCcVisa, FaCcMastercard, FaDownload, FaCalendarAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaFilter, FaTimes, FaCheckCircle } from "react-icons/fa";
import PaginationItem from '@mui/material/PaginationItem';
import { Base_Url, topUpList, userTrnxList } from '../../../../config/config';

const TopupHistory = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  const cus_id = localStorage.getItem('cus_id');
  const [totalOrders, setTotalOrders] = useState(0);
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const [historyData, setHistoryData] = useState([]);
  const [allHistoryData, setAllHistoryData] = useState([]);
  const navigate = useNavigate();

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isDateFilterActive, setIsDateFilterActive] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const handleNavigation = () => {
    navigate('/dashboard');
  };

  const getTopupHistory = async () => {
    const apiEndpoint = role === 'admin' ? userTrnxList : topUpList;
    const url = `${Base_Url}${apiEndpoint}?page=${page}&limit=${limit}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (data.status === 'SUCCESS') {
        const transactions = data.data;

        if (isDateFilterActive) {
          const filtered = applyDateFilter(transactions);
          setHistoryData(filtered);
          setTotalOrders(filtered.length);
        } else {
          setHistoryData(transactions);
          setTotalOrders(data.pagination.totalItems || 0);
        }

        setAllHistoryData(prev => {
          const combinedData = [...prev];

          transactions.forEach(transaction => {
            if (!combinedData.some(item => item.id === transaction.id)) {
              combinedData.push(transaction);
            }
          });

          return combinedData;
        });
      } else {
        toast.error(`Error: ${data.message}`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const fetchAllData = async () => {
    const apiEndpoint = role === 'admin' ? userTrnxList : topUpList;
    const url = `${Base_Url}${apiEndpoint}?page=1&limit=1000`;

    try {
      toast.loading('Preparing data...');
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      toast.dismiss();

      if (data.status === 'SUCCESS') {
        const allData = data.data;
        return isDateFilterActive ? applyDateFilter(allData) : allData;
      } else {
        toast.error(`Error: ${data.message}`);
        return [];
      }
    } catch (error) {
      toast.dismiss();
      toast.error(`Error: ${error.message}`);
      return [];
    }
  };

  useEffect(() => {
    getTopupHistory();
  }, [page, limit]);

  useEffect(() => {
    if (isDateFilterActive) {
      const filtered = applyDateFilter(allHistoryData);
      setFilteredData(filtered);

      const paginatedData = filtered.slice((page - 1) * limit, page * limit);
      setHistoryData(paginatedData);
      setTotalOrders(filtered.length);
    } else {
      getTopupHistory();
    }
  }, [isDateFilterActive, startDate, endDate]);

  useEffect(() => {
    if (isDateFilterActive) {
      const paginatedData = filteredData.slice((page - 1) * limit, page * limit);
      setHistoryData(paginatedData);
    }
  }, [page, limit, filteredData]);

  const applyDateFilter = (data) => {
    if (!startDate || !endDate) return data;

    const startTimestamp = new Date(startDate).setHours(0, 0, 0, 0);
    const endTimestamp = new Date(endDate).setHours(23, 59, 59, 999);

    return data.filter(item => {
      const txnDate = new Date(item.txn_date).getTime();
      return txnDate >= startTimestamp && txnDate <= endTimestamp;
    });
  };

  const handleApplyDateFilter = () => {
    if (!startDate || !endDate) {
      toast.warning('Please select both start and end dates');
      return;
    }

    if (new Date(startDate) > new Date(endDate)) {
      toast.warning('Start date cannot be after end date');
      return;
    }

    setIsDateFilterActive(true);
    setPage(1);
  };

  const handleResetDateFilter = () => {
    setStartDate('');
    setEndDate('');
    setIsDateFilterActive(false);
    setPage(1);
  };

  const convertToCSV = (data) => {
    const headers = role === 'admin'
      ? ['User ID', 'Transaction ID', 'Amount', 'Last Balance', 'Transaction Type', 'Transaction Status', 'Transaction Date']
      : ['Transaction ID', 'Amount', 'Last Balance', 'Transaction Type', 'Transaction Status', 'Transaction Date'];

    let csvContent = headers.join(',') + '\n';

    data.forEach(row => {
      const values = role === 'admin'
        ? [
          `"${row.user_id || 'N/A'}"`,
          `"${row.trnx_id || 'N/A'}"`,
          `"${row.credit_amount || 'N/A'}"`,
          `"${row.closing_balance || 'N/A'}"`,
          `"${row.payment_mode || 'N/A'}"`,
          `"${row.status === 'add' ? 'Success' : row.status || 'N/A'}"`,
          `"${row.txn_date || 'N/A'}"`,
        ]
        : [
          `"${row.trnx_id || 'N/A'}"`,
          `"${row.credit_amount || 'N/A'}"`,
          `"${row.closing_balance || 'N/A'}"`,
          `"${row.payment_mode || 'N/A'}"`,
          `"${row.status === 'add' ? 'Success' : row.status || 'N/A'}"`,
          `"${row.txn_date || 'N/A'}"`,
        ];

      csvContent += values.join(',') + '\n';
    });

    return csvContent;
  };

  const downloadTopupHistory = async () => {
    try {
      toast.loading('Preparing download...');

      const dataToExport = await fetchAllData();

      if (dataToExport.length === 0) {
        toast.dismiss();
        toast.error('No data available to download');
        return;
      }

      const csvContent = convertToCSV(dataToExport);

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', `topup-history-${startDate || 'all'}-to-${endDate || 'all'}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.dismiss();
      toast.success('Download successful');
    } catch (error) {
      toast.dismiss();
      toast.error(`Download failed: ${error.message}`);
    }
  };

  const renderTableHeaders = () => {
    const headers = [
      'Transaction ID',
      'Amount',
      'Last Balance',
      'Transaction Type',
      'Transaction Status',
      'Transaction Date',
      'Description',
    ];
    if (role === 'admin') headers.unshift('User ID');
    return headers;
  };

  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value));
    setPage(1);
  };

  const renderTableRow = (row, index) => (
    <tr
      key={row.id}
      className={`transition-colors duration-150 ${
        isDarkMode
          ? index % 2 === 0 ? 'bg-[#111827] hover:bg-[#1F2937]' : 'bg-[#0F172A] hover:bg-[#1F2937]'
          : 'hover:bg-gray-50'
      }`}
    >
      {role === 'admin' && (
        <td className={`px-3 py-2 text-xs font-medium whitespace-nowrap ${
          isDarkMode ? 'text-gray-200' : 'text-black'
        }`}>
          {row.user_id}
        </td>
      )}
      <td className={`relative group px-3 py-2 text-xs font-semibold cursor-pointer whitespace-nowrap ${
        isDarkMode ? 'text-indigo-300' : 'text-black'
      }`}>
        {row.trnx_id || "N/A"}
        <div className={`absolute left-0 top-full mt-1 hidden group-hover:block text-white text-[10px] rounded-md px-2 py-1 shadow-lg z-10 whitespace-nowrap ${
          isDarkMode ? 'bg-[#1F2937] border border-gray-700' : 'bg-black'
        }`}>
          View transaction details
        </div>
      </td>
      <td className={`px-3 py-2 text-xs font-bold whitespace-nowrap ${
        isDarkMode ? 'text-emerald-400' : 'text-black'
      }`}>
        ₹{row.credit_amount || "N/A"}
      </td>
      <td className={`px-3 py-2 text-xs whitespace-nowrap ${
        isDarkMode ? 'text-gray-300' : 'text-gray-700'
      }`}>
        ₹{row.closing_balance || "N/A"}
      </td>
      <td className={`px-3 py-2 text-xs capitalize whitespace-nowrap ${
        isDarkMode ? 'text-gray-300' : 'text-gray-700'
      }`}>
        {row.payment_mode || "N/A"}
      </td>
      <td className="px-3 py-2 whitespace-nowrap">
        {row.status === 'add' ? (
          <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold border ${
            isDarkMode
              ? 'bg-emerald-500/10 text-emerald-300 border-emerald-500/40 shadow-[0_0_10px_rgba(16,185,129,0.2)]'
              : 'bg-green-500 text-white'
          }`}>
            <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
              isDarkMode ? 'bg-emerald-400 animate-pulse' : 'bg-white'
            }`}></span>
            Success
          </span>
        ) : (
          <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold border ${
            isDarkMode
              ? 'border-gray-600/60 text-gray-400 bg-gray-800/40'
              : 'border-gray-400 text-gray-600'
          }`}>
            {row.status}
          </span>
        )}
      </td>
      <td className={`px-3 py-2 text-xs whitespace-nowrap ${
        isDarkMode ? 'text-gray-400' : 'text-gray-700'
      }`}>
        {row.txn_date || "N/A"}
      </td>
      <td className={`px-3 py-2 text-xs max-w-[180px] ${
        isDarkMode ? 'text-gray-400' : 'text-gray-700'
      }`}>
        <div
          className="truncate hover:text-clip hover:whitespace-normal cursor-help"
          title={row.txn_description || "No description available"}
        >
          {row.txn_description || "N/A"}
        </div>
      </td>
    </tr>
  );

  const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

  return (
    <div className={`h-screen flex flex-col overflow-hidden transition-colors duration-300 ${
      isDarkMode ? 'dark bg-[#0B1120]' : 'bg-white'
    }`}>
      {/* Premium ambient glows */}
      {isDarkMode ? (
        <>
          <div className="pointer-events-none absolute -top-40 -left-32 h-[500px] w-[500px] rounded-full bg-indigo-600/15 blur-[120px]" />
          <div className="pointer-events-none absolute bottom-0 -right-32 h-[400px] w-[400px] rounded-full bg-purple-600/10 blur-[100px]" />
        </>
      ) : (
        <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 blur-3xl" />
      )}

      <NavBar />
      <div className="flex flex-1 overflow-hidden relative z-10">
                             <div
            className={`
              ${isToggleSidebar ? "w-64" : "w-[72px]"}
              m-3
              rounded-3xl
              ${glass}
              overflow-hidden
              transition-all
              duration-300
              ease-in-out
            `}
          >
            <Sidebar />
          </div>

        {/* Main panel */}
        <div className={`w-full flex flex-col flex-1 overflow-hidden p-3 transition-colors duration-300 ${
          isDarkMode ? 'bg-[#0B1120] text-white' : 'bg-gray-200'
        }`}>

          {/* Premium Header Button */}
          <button
            onClick={handleNavigation}
            className={`shrink-0 text-sm font-bold rounded-xl h-10 w-full sm:w-auto sm:px-6 flex items-center justify-center gap-2 transition-all duration-300 ${
              isDarkMode
                ? 'bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-600 text-white shadow-[0_0_25px_rgba(99,102,241,0.3)] hover:shadow-[0_0_40px_rgba(99,102,241,0.5)]'
                : 'bg-blue-600 text-white hover:bg-gray-800'
            }`}
          >
            <FaCcVisa size={16} />
            <FaCcMastercard size={16} />
            TopUp History
          </button>

          {/* Premium Filter Bar */}
          <div className={`shrink-0 mt-3 p-3 rounded-2xl border transition-colors duration-300 ${
            isDarkMode
              ? 'bg-white/[0.02] border-white/[0.08]'
              : 'bg-gray-50 border-gray-200'
          }`}>
            <div className="flex flex-col md:flex-row items-start md:items-end gap-3">
              <div className="flex flex-col w-full md:w-auto">
                <label className={`text-[10px] font-bold uppercase tracking-wider mb-1 ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                }`}>Start Date</label>
                <div className="relative">
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className={`rounded-xl p-2 pr-8 w-full md:w-40 text-xs focus:outline-none transition-all duration-300 ${
                      isDarkMode
                        ? 'bg-white/[0.03] border border-white/10 text-white focus:border-indigo-500/60 focus:bg-white/[0.06] focus:ring-2 focus:ring-indigo-500/20'
                        : 'border border-gray-300 bg-white focus:ring-2 focus:ring-blue-500/20'
                    }`}
                  />
                </div>
              </div>

              <div className="flex flex-col w-full md:w-auto">
                <label className={`text-[10px] font-bold uppercase tracking-wider mb-1 ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                }`}>End Date</label>
                <div className="relative">
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className={`rounded-xl p-2 pr-8 w-full md:w-40 text-xs focus:outline-none transition-all duration-300 ${
                      isDarkMode
                        ? 'bg-white/[0.03] border border-white/10 text-white focus:border-indigo-500/60 focus:bg-white/[0.06] focus:ring-2 focus:ring-indigo-500/20'
                        : 'border border-gray-300 bg-white focus:ring-2 focus:ring-blue-500/20'
                    }`}
                  />
                </div>
              </div>

              <div className="flex flex-wrap gap-2 w-full md:w-auto md:ml-auto">
                <button
                  onClick={handleApplyDateFilter}
                  className={`rounded-xl px-3.5 py-2 text-xs font-bold flex items-center justify-center gap-1.5 flex-grow md:flex-grow-0 transition-all duration-300 ${
                    isDarkMode
                      ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:shadow-[0_0_20px_rgba(99,102,241,0.5)] hover:scale-[1.02]'
                      : 'bg-blue-700 text-white hover:bg-gray-800'
                  }`}
                >
                  <FaFilter size={11} />
                  Apply
                </button>

                {isDateFilterActive && (
                  <button
                    onClick={handleResetDateFilter}
                    className={`rounded-xl px-3.5 py-2 text-xs font-bold flex items-center justify-center gap-1.5 flex-grow md:flex-grow-0 border transition-all duration-300 ${
                      isDarkMode
                        ? 'bg-white/[0.03] border-white/10 text-gray-300 hover:bg-white/[0.06] hover:border-white/20'
                        : 'bg-white border-gray-300 text-black hover:bg-gray-100'
                    }`}
                  >
                    <FaTimes size={11} />
                    Reset
                  </button>
                )}

                <button
                  onClick={downloadTopupHistory}
                  className={`rounded-xl px-3.5 py-2 text-xs font-bold flex items-center justify-center gap-1.5 flex-grow md:flex-grow-0 transition-all duration-300 ${
                    isDarkMode
                      ? 'bg-gradient-to-r from-emerald-600 to-green-600 text-white hover:shadow-[0_0_20px_rgba(16,185,129,0.5)] hover:scale-[1.02]'
                      : 'bg-red-600 text-white hover:bg-red-700'
                  }`}
                >
                  <FaDownload size={11} />
                  Download
                </button>
              </div>
            </div>

            {isDateFilterActive && (
              <div className={`mt-2.5 text-[10px] font-semibold flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border ${
                isDarkMode
                  ? 'text-emerald-300 bg-emerald-500/5 border-emerald-500/20'
                  : 'text-black'
              }`}>
                <FaCheckCircle size={11} />
                Showing {new Date(startDate).toLocaleDateString()} – {new Date(endDate).toLocaleDateString()}
              </div>
            )}
          </div>

          {/* Premium Table */}
          <div className={`flex-1 min-h-0 mt-3 rounded-xl border overflow-auto custom-scrollbar transition-colors duration-300 ${
            isDarkMode
              ? 'border-gray-800 bg-[#111827] shadow-[0_0_30px_rgba(0,0,0,0.4)]'
              : 'border-gray-200'
          }`}>
            <table className="min-w-full table-auto text-left">
              <thead className={`sticky top-0 z-[1] text-[10px] uppercase tracking-wider transition-colors duration-300 ${
                isDarkMode
                  ? 'bg-gradient-to-r from-[#1F2937] via-[#1a2332] to-[#1F2937] text-gray-300 border-b border-gray-700'
                  : 'bg-blue-600 text-white'
              }`}>
                <tr>
                  {renderTableHeaders().map((header, index) => (
                    <th key={index} className="px-3 py-2.5 font-semibold whitespace-nowrap">
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className={`divide-y transition-colors duration-300 ${
                isDarkMode ? 'divide-gray-800' : 'divide-gray-100'
              }`}>
                {historyData?.length > 0 ? (
                  historyData.map((row, index) => renderTableRow(row, index))
                ) : (
                  <tr>
                    <td colSpan={role === 'admin' ? "8" : "7"} className={`text-center p-6 text-xs ${
                      isDarkMode ? 'text-gray-500' : 'text-gray-400'
                    }`}>
                      {isDateFilterActive ? 'No data available for the selected date range' : 'No data available'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Premium Footer / Pagination */}
          <div className="shrink-0 mt-3 flex flex-col sm:flex-row justify-between items-center gap-2">
            <span className={`text-xs font-semibold ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              Total: <span className={isDarkMode ? 'text-indigo-300' : ''}>{totalOrders}</span>
            </span>

            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className={`rounded-lg px-2.5 py-1 text-xs focus:outline-none transition-all duration-300 ${
                isDarkMode
                  ? 'bg-[#1F2937] border border-gray-700 text-gray-200 focus:ring-1 focus:ring-indigo-500'
                  : 'border border-gray-300 bg-white text-gray-700'
              }`}
            >
              {totalOrders === 0 ? (
                <option value={0}>0</option>
              ) : (
                <>
                  {totalOrders >= 10 && <option value={10}>10</option>}
                  {totalOrders >= 15 && <option value={15}>15</option>}
                  {totalOrders >= 20 && <option value={20}>20</option>}
                  {totalOrders >= 30 && <option value={30}>30</option>}
                  {totalOrders >= 30 && <option value={totalOrders}>All</option>}
                </>
              )}
            </select>

            <Pagination
              count={Math.ceil(totalOrders / limit)}
              page={page}
              onChange={handlePaginationChange}
              variant="outlined"
              shape="rounded"
              size="small"
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  sx={{
                    borderRadius: '8px',
                    color: isDarkMode ? '#E5E7EB' : '#374151',
                    borderColor: isDarkMode ? '#374151' : '#d1d5db',
                    '&.Mui-selected': {
                      backgroundColor: isDarkMode ? 'rgba(99,102,241,0.2)' : '#000',
                      color: isDarkMode ? '#a5b4fc' : '#fff',
                      borderColor: isDarkMode ? '#6366f1' : '#000',
                      boxShadow: isDarkMode ? '0 0 10px rgba(99,102,241,0.4)' : 'none',
                    },
                    '&:hover': {
                      backgroundColor: isDarkMode ? 'rgba(99,102,241,0.1)' : '#F3F4F6',
                    }
                  }}
                />
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopupHistory;